<app-help-header></app-help-header>
<div class="help-layout p-0">

  <div class="help-sidebar p-0">
    <app-help-side-bar class="p-0"></app-help-side-bar>
  </div>

  <div class="help-content">
    <router-outlet></router-outlet>
  </div>

  <!--<div class="help-right-nav">
    <app-help-right-side-sec></app-help-right-side-sec>
  </div>-->

</div>
